module.exports = __webpack_public_path__ + "fonts/PrestigeEliteStd-BdSlanted.1ee0fcde.woff";